export default __webpack_public_path__ + "static/fonts/HelveticaNeue-Bold.6a1c054.woff";